import * as ip from "../utils/ip";

module.exports = class ipv4 {
    getState() {
        return new Promise(function (resolve) {
            ip.getV4Data().then(() => {
                resolve("ok");
            }).catch(() => {
                resolve("fail");
            });
        });
    }
};



// WEBPACK FOOTER //
// ./frontend/connection_tests/ipv4.js